import cn from 'classnames'
import { IconName } from '@/assets/icons/interfaces'
import { Icon } from '@/components'
import styles from './AreaPageMenu.module.scss'

type AreaPageMenuProps = {
  isShowStageButton?: boolean
  isShowSubscriptionButton?: boolean
  isShowEventButton?: boolean
  handleStageButtonClick: () => void
  handleSubscriptionButtonClick: () => void
  handleEventButtonClick: () => void
  handleFinesButtonClick: () => void
  isDisabled: boolean
  isFindStageLoading: boolean
  isStrictSearchLoading: boolean
}

export const AreaPageMenu = ({
  isShowStageButton,
  isShowSubscriptionButton,
  isShowEventButton,
  handleStageButtonClick,
  handleSubscriptionButtonClick,
  handleEventButtonClick,
  handleFinesButtonClick,
  isFindStageLoading,
  isStrictSearchLoading,
  isDisabled,
}: AreaPageMenuProps) => {
  const isButtonWithoutLineBreak = !isShowSubscriptionButton || !isShowEventButton

    return (
    <div className={styles.container}>
      <nav className={styles.menu}>
        {isShowStageButton && (
          <MenuButton
            text="Оплатить парковку"
            onClick={handleStageButtonClick}
            icon="barrier-up-icon"
            isDisabled={isDisabled || isFindStageLoading || isStrictSearchLoading}
            isLoading={isFindStageLoading && !isStrictSearchLoading}
            isAccent
            withoutLineBreak
          />
        )}
        <div className={styles.menu__buttons}>
          {isShowSubscriptionButton && (
            <MenuButton
              text="Купить абонемент"
              onClick={handleSubscriptionButtonClick}
              icon="subscription-icon"
              withoutLineBreak={isButtonWithoutLineBreak}
              isDisabled={isDisabled || isFindStageLoading || isStrictSearchLoading}
              isLoading={isStrictSearchLoading}
            />
          )}
          {isShowEventButton && (
            <MenuButton
              text="Оплатить мероприятие"
              onClick={handleEventButtonClick}
              icon="event-icon"
              withoutLineBreak={isButtonWithoutLineBreak}
              isDisabled={isDisabled || isFindStageLoading || isStrictSearchLoading}
            />
          )}
          <MenuButton
            text="Оплатить штраф"
            onClick={handleFinesButtonClick}
            icon="attention-white-icon"
            isDisabled={isDisabled || isFindStageLoading || isStrictSearchLoading}
            isLoading={isStrictSearchLoading}
            withoutLineBreak={isButtonWithoutLineBreak}
          />
        </div>
      </nav>
    </div>
  )
}

const MenuButton = ({
  text,
  icon,
  isAccent,
  withoutLineBreak,
  onClick,
  isDisabled,
  isLoading,
}: {
  text: string
  icon: IconName
  isAccent?: boolean
  withoutLineBreak: boolean
  onClick: () => void
  isDisabled: boolean
  isLoading?: boolean
}) => {
  return (
    <button
      className={cn(styles.menu__button, {
        [styles.menu__button_accent]: isAccent,
        [styles.menu__button_loading]: isLoading,
        [styles.menu__button_without_line_break]: withoutLineBreak,
      })}
      onClick={onClick}
      disabled={isDisabled}
    >
      <div>
        <Icon name={isLoading ? 'spinner' : icon} />
        {!isLoading && <span>{text}</span>}
      </div>
    </button>
  )
}
